import React, { useContext, useEffect, useState } from 'react';
import { View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import ClientContext from 'app/src/contexts/ClientContext';
import { Fields, defaultValues, EMAIL_PATTERN } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Notice } from 'app/src/elements/Notice';
import { Title, Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

import { PROFILE_SELECTS, UPDATE_CURRENT_USER } from './queries';

const FIELDS = {
  email: {
    rules: {
      required: true,
      pattern: { value: EMAIL_PATTERN, message: 'Enter a valid email' },
    },
  },
  name: { rules: { required: true } },
  defaultClientId: {
    label: 'Default Client',
    hint: 'Optional',
    type: 'hidden',
  },
};

const Profile = () => {
  const { currentUser, refetchCurrentUser } = useContext(ClientContext);
  const [formStatus, setFormStatus] = useState();
  const [showCloseAccount, setShowCloseAccount] = useState(false);

  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource: currentUser  })
  });

  const { data: selects } = useQuery(PROFILE_SELECTS);

  const [updateCurrentUser] = useMutation(UPDATE_CURRENT_USER, {
    onCompleted: () => {
      setFormStatus('submitted');
      refetchCurrentUser();
    }
  });

  useEffect(() => {
    if (currentUser) {
      reset(
        defaultValues({ fields: FIELDS, resource: currentUser  })
      );
    }
  }, [currentUser]);

  const onSubmit = input => {
    setFormStatus('submitting');
    const { id, ...inputData } = input;
    updateCurrentUser({ variables: { input: inputData } });
  };

  const fields = { ...FIELDS };

  if (selects) {
    fields.defaultClientId = { ...fields.defaultClientId };

    fields.defaultClientId.type = null;
    fields.defaultClientId.select = [
      { value: '', label: 'Select' },
      ...selects.clients.edges
        .map(edge => ({ value: edge.node.id, label: edge.node.name }))
    ];
  }

  return (
    <View>
      <Title>Update Your Profile</Title>

      {'submitted' === formStatus && (
        <Notice type="success">
          Your profile has been updated.
        </Notice>
      )}

      <Fields fields={fields} control={control} errors={errors} />

      <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
    </View>
  );
};

export default Profile;
